(function () {
    'use strict';

    // @ngInject
    Components.HomeSetupGuideBanner = {
        controller: function HomeSetupGuideBannerController(
            $scope,
            $element,
            $attrs,
            $timeout,
            AppStates,
            SetupGuideService
        ) {
            this.SetupGuideService = SetupGuideService;
            this.AppStates = AppStates;
            this.completedPercentage = SetupGuideService.setupGuideStats.completion;

            // Sometimes, SetupGuideService completion hasn't calculated yet.
            // If so, query again until found.
            var checkForSetupGuideCompletion = function() {
                if (this.completedPercentage === 0) {
                    $timeout(function() {
                        this.completedPercentage = SetupGuideService.setupGuideStats.completion;
                        checkForSetupGuideCompletion();
                    }.bind(this), 1000)
                }
            }.bind(this);
            checkForSetupGuideCompletion();
        },
        name: 'hbHomeSetupGuideBanner',
        templateUrl: 'angular/app/modules/core/features/home/setup_guide_banner/setup_guide_banner_component_template.html',
    };

}());